import React from "react";
import PropTypes from "prop-types";
import { formatRemaining } from "./sessionState";
import "./sessionWarningBanner.scss";

const SessionWarningBanner = ({ remainingMs }) => (
    <div className="rdc-session-banner" role="alert" aria-live="assertive">
        <p className="rdc-session-banner__text">
            You'll be signed out in{" "}
            <span className="rdc-session-banner__count">{formatRemaining(remainingMs)}</span> due to
            inactivity — move the mouse or press a key to stay signed in.
        </p>
    </div>
);

SessionWarningBanner.propTypes = {
    remainingMs: PropTypes.number.isRequired,
};

export default SessionWarningBanner;
